__turbopack_context__.v({
  "button": "Button-module__cGUqGa__button",
});
